import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-payment-review" }
const _hoisted_2 = { class: "profile-payment-review-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Revisar datos de pago", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Si sigues teniendo la misma tarjeta, comprueba que dispone de fondos y que no has alcanzado los límites de tarjeta. En caso de haber cambiado, puedes editar los datos en “Métodos de Pago“ ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        alt: "profile-payment-review-icon",
        src: require('@/assets/images/alert-icon.png')
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    _hoisted_5,
    _createVNode(_component_Button, {
      variant: "turquoise outlined",
      onClick: _ctx.retryPayment
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Reintentar pago ")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}